// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pgKfg","deleteButton":"styles_deleteButton__62hkF","backButton":"styles_backButton__9RUqU","applyButton":"styles_applyButton__OC8qs"};